import {Image} from '@/_application/core/components/ui/image';
import CheckIcon from '@/_application/icons/check-icon';
import {ProductAttributeProps} from '@/_application/modules/products/components/attributes/product.attribute';
import {Colors} from '@/framework/static/colors';
import cn from 'classnames';

export const ColorAttribute = ({attribute, currentOption, isDisabled, onSelected}: ProductAttributeProps) => {
    const handleSelectColor = () => {
        if (onSelected && attribute.value_index) {
            onSelected(attribute.value_index);
        }
    };
    const isSelected = currentOption === attribute.value_index;
    const colorOption = Colors.find(item => attribute.value_index === item.option_id);
    // a list value index of light color, example white color
    const lightColorValues = [2302, 2301];
    return (
        <>
            {colorOption?.value.startsWith('#') ? (
                <button
                    aria-label="Thuộc tính màu sắc"
                    onClick={handleSelectColor}
                    className={cn(
                        'flex h-5 w-5 cursor-pointer items-center justify-center rounded-full border border-KPZ_Border',
                        {
                            'cursor-not-allowed! opacity-80': isDisabled,
                        },
                    )}
                    style={{background: colorOption?.value}}
                    title={attribute.label!}
                    disabled={isDisabled}>
                    {isDisabled && <div className="h-full w-0.5 rotate-45 bg-KPZ_Red" />}
                    {isSelected && (
                        <CheckIcon
                            className={cn('h-4 w-4', {
                                'text-black': lightColorValues.includes(attribute.value_index!),
                                'text-white': !lightColorValues.includes(attribute.value_index!),
                            })}
                        />
                    )}
                </button>
            ) : (
                <button
                    aria-label="Thuộc tính màu sắc"
                    className={cn('relative  h-5 w-5 cursor-pointer rounded-full border', {
                        'border border-KPZ_Border!': isSelected,
                        'cursor-not-allowed! opacity-30': isDisabled,
                    })}
                    onClick={handleSelectColor}
                    disabled={isDisabled}>
                    <Image
                        className={'rounded-full'}
                        src={`https://cdn-v2.kidsplaza.vn/media/attribute/swatch/swatch_thumb/110x90/${colorOption?.value ?? ''}`}
                        alt={attribute.label!}
                        title={attribute.label!}
                        width={20}
                        height={20}
                    />
                </button>
            )}
        </>
    );
};
